<script setup>
import PageHero from '@/views/front-pages/PageHero.vue'
import PublicPageShell from '@/views/front-pages/PublicPageShell.vue'
import { useConfigStore } from '@core/stores/config'

definePage({ meta: { layout: 'blank', public: true } })

const store = useConfigStore()

store.skin = 'default'

// Patch (halaman legal & bantuan): "Pusat Bantuan" publik ini SENGAJA tidak
// menduplikasi sistem tiket -- sistem tiket (Addendum 14, pages/support/
// index.vue, route name 'support') memang butuh login (subject: 'Ticket'),
// sama seperti link "Dashboard" yang sudah ada di LandingFooter.vue: klik
// dari sini tanpa login akan diarahkan ke halaman login dulu, itu perilaku
// normal yang sudah ada, bukan bug baru dari halaman ini.
const helpPaths = [
  {
    icon: 'ri-ticket-2-line',
    color: 'primary',
    title: 'Sudah Jadi Pelanggan?',
    desc: 'Masuk ke akun Anda dan buka tiket bantuan -- tim kami akan merespons langsung dari sana.',
    action: { name: 'support' },
    actionLabel: 'Buka Tiket Bantuan',
  },
  {
    icon: 'ri-questionnaire-line',
    color: 'info',
    title: 'Masih Menimbang-nimbang?',
    desc: 'Cek dulu pertanyaan yang paling sering ditanyakan seputar paket, fitur, dan cara kerja PintuKasir.',
    action: { path: '/#faq' },
    actionLabel: 'Lihat FAQ',
  },
  {
    icon: 'ri-whatsapp-line',
    color: 'success',
    title: 'Butuh Ngobrol Langsung?',
    desc: 'Hubungi tim kami lewat WhatsApp atau email untuk pertanyaan yang belum terjawab di FAQ.',
    action: { path: '/kontak' },
    actionLabel: 'Hubungi Kami',
  },
]
</script>

<template>
  <PublicPageShell>
    <PageHero
      eyebrow="Pusat Bantuan"
      eyebrow-icon="ri-customer-service-2-line"
      title="Ada yang Bisa Kami Bantu?"
      subtitle="Pilih jalur yang paling sesuai dengan kebutuhan Anda di bawah ini."
    />

    <section class="help-section pb-16">
      <VContainer>
        <VRow justify="center">
          <VCol
            v-for="item in helpPaths"
            :key="item.title"
            cols="12"
            md="4"
          >
            <VCard
              class="help-card h-100"
              rounded="lg"
              variant="outlined"
            >
              <VCardText class="pa-6 text-center d-flex flex-column">
                <div
                  class="help-icon-wrap mx-auto mb-4"
                  :class="`help-icon-wrap--${item.color}`"
                >
                  <VIcon
                    :icon="item.icon"
                    size="26"
                    :color="item.color"
                  />
                </div>
                <h3 class="text-body-1 font-weight-bold mb-2">
                  {{ item.title }}
                </h3>
                <p class="text-body-2 text-medium-emphasis mb-5 flex-grow-1">
                  {{ item.desc }}
                </p>
                <VBtn
                  :color="item.color"
                  variant="tonal"
                  :to="item.action"
                >
                  {{ item.actionLabel }}
                </VBtn>
              </VCardText>
            </VCard>
          </VCol>
        </VRow>
      </VContainer>
    </section>
  </PublicPageShell>
</template>

<style lang="scss" scoped>
.help-card {
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(var(--v-shadow-key-umbra-color), 12%) !important;
    transform: translateY(-2px);
  }
}

.help-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 14px;

  &--primary { background: rgba(var(--v-theme-primary), 0.12); }
  &--info { background: rgba(var(--v-theme-info), 0.12); }
  &--success { background: rgba(var(--v-theme-success), 0.12); }
}
</style>
